import Api from '.';
import { endpoints } from './endpoints';

export default class LoginApi extends Api {

    generateOtp(data) {
        console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.login.generateOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    verifyOtp(data) {
        let url = this.buildUrl(endpoints.login.verifyOtp)
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    logout() {
        let url = this.buildUrl(endpoints.login.logout)
        return this.fetch(url, "POST").then(response => response);
    }

    logoutNew() {
        let url = this.buildUrl(endpoints.login.logoutNew)
        return this.fetch(url, "POST").then(response => response);
    }

    common(data) {
        let url = this.buildUrl(endpoints.login.common, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    CheckAIFDITPan(data) {
        let url = this.buildUrl(endpoints.login.CheckAIFDITPan, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    CheckPMSDITPan(data) {
        let url = this.buildUrl(endpoints.login.CheckPMSDITPan, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    GetDITUserDetails(data) {
        let url = this.buildUrl(endpoints.login.GetDITUserDetails, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    CheckMFPanDist(data) {
        let url = this.buildUrl(endpoints.login.CheckMFPanDist, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    GetFundDetails(data) {
        let url = this.buildUrl(endpoints.login.GetFundDetails, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    AddNAVDetails(data) {
        let url = this.buildUrl(endpoints.login.AddNAVDetails, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    GetNAVHistoryDetails(data) {
        let url = this.buildUrl(endpoints.login.GetNAVHistoryDetails, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

    MissedUpdateAlert(data) {
        let url = this.buildUrl(endpoints.login.MissedUpdateAlert, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }

}